module.exports = __webpack_public_path__ + "static/media/01-02compesit.b0ff7b2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/01-02compesit.mp4
// module id = NzQC
// module chunks = 1